module.exports = __webpack_public_path__ + "static/media/bridge.a24628c9.jpg";